import * as React from 'react';
import * as styles from './styles.css';

import { RgrTooltip } from './RgrTooltip';
import { Paragraph3, TooltipDesktop } from '@cian/ui-kit';
import cn from 'clsx';
export enum AgentType {
  Realtor = 'realtor',
  Agency = 'agency',
}

export interface IRgrCertificateProps {
  type: AgentType;
  size?: 'S' | 'M';
  withText?: boolean;
}

export const RgrCertificate = (props: IRgrCertificateProps) => {
  const { type, size = 'S', withText } = props;

  return (
    <TooltipDesktop title={<RgrTooltip type={type} />} theme="white" placement="right-start">
      <div className={cn(withText ? styles['rgr-block'] : styles['rgr-inline'])}>
        <div className={cn(styles['title-icon'], styles[`icon-size_${size.toLowerCase()}`])} />
        {withText && <Paragraph3 color="gray60_100">Сертификат РГР</Paragraph3>}
      </div>
    </TooltipDesktop>
  );
};
